module.exports = __webpack_public_path__ + "static/media/undo.f13704f4.svg";